import i18n from '../../../i18n';

export type BankVerifyText = {
  title: string;
  sentTo: string;
  placeholder: string;
  send: string;
  switchTo: string;
  sms: string;
  email: string;
  confirm: string;
  noPhone: string;
  noEmail: string;
  sendFail: string;
  codeRequired: string;
  encryptFail: string;
  submitFail: string;
  puzzleHint: string;
  verifying: string;
  passed: string;
  verifyFail: string;
  loadFail: string;
  unavailable: string;
};

export const bankVerifyText = (): BankVerifyText => ({
  title: i18n.BankList.VerifyTitle,
  sentTo: i18n.BankList.VerifySentTo,
  placeholder: i18n.BankList.VerifyPlaceholder,
  send: i18n.BankList.VerifySend,
  switchTo: i18n.BankList.VerifySwitchTo,
  sms: i18n.BankList.VerifySms,
  email: i18n.BankList.VerifyEmail,
  confirm: i18n.Common.Confirm,
  noPhone: i18n.BankList.VerifyNoPhone,
  noEmail: i18n.BankList.VerifyNoEmail,
  sendFail: i18n.BankList.VerifySendFail,
  codeRequired: i18n.BankList.VerifyCodeRequired,
  encryptFail: i18n.BankList.VerifyEncryptFail,
  submitFail: i18n.BankList.VerifySubmitFail,
  puzzleHint: i18n.BankList.VerifyPuzzleHint,
  verifying: i18n.BankList.VerifyVerifying,
  passed: i18n.BankList.VerifyPassed,
  verifyFail: i18n.BankList.VerifyFail,
  loadFail: i18n.BankList.VerifyLoadFail,
  unavailable: i18n.BankList.VerifyUnavailable,
});

const digitsOf = (raw: unknown) => String(raw ?? '').replace(/\D/g, '');

/** 大陆规则脱敏，不看区号。13812345678 → 138****78 */
export const maskBankPhone = (raw: unknown) => {
  const digits = digitsOf(raw);
  const length = digits.length;
  if (!length) return '';
  if (length === 1) return '*';
  if (length <= 3) return `${digits.slice(0, 1)}***${digits.slice(-1)}`;
  if (length < 5) return `${digits.slice(0, 2)}***${digits.slice(-1)}`;
  return `${digits.slice(0, 3)}****${digits.slice(-2)}`;
};

/** ab@x.com → ab***@x.com；没有 @ 则 *** */
export const maskBankEmail = (raw: unknown) => {
  const text = String(raw ?? '').trim();
  const at = text.indexOf('@');
  if (at <= 0) return '***';
  const local = text.slice(0, at);
  const domain = text.slice(at);
  if (local.length === 1) return `*${domain}`;
  return `${local.slice(0, 2)}***${domain}`;
};
